import { Box } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./navigation-sub-menu.scss";
import { useIsChildRouteEnabled } from "components/navigation/hooks/useIsChildRouteEnabled";
import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { NavigationSubMenuItem } from "components/navigation/navigation-panel/sub-navigation-panel/contents/navigation-sub-menu-item/NavigationSubMenuItem";
import { RouteDefinition } from "components/router/Routes";

interface Props {
    mainRoute: RouteDefinition | undefined;
}

const NavigationSubMenu = (props: Props) => {
    const { t } = useTranslation();
    const isRouteEnabled = useIsRouteEnabled();
    const { isChildRouteEnabled, isChildRouteAdvertised } = useIsChildRouteEnabled();

    if (!props.mainRoute || !isRouteEnabled(props.mainRoute)) {
        return null;
    }

    const renderChildRoutes = (routes: RouteDefinition[]) => {
        const enabledRoutes = routes.filter((route) => isChildRouteEnabled(route));
        if (enabledRoutes.length === 0) {
            return null;
        }

        return (
            <ul className={style.subMenuList}>
                {enabledRoutes.map((route) => (
                    <li key={route.path}>
                        {route.childRoutes.length > 0 ? (
                            t(route.title)
                        ) : (
                            <NavigationSubMenuItem
                                to={route.path}
                                isAdvertised={isChildRouteAdvertised(route)}
                                testId={route.testId}
                            >
                                {t(route.title)}
                            </NavigationSubMenuItem>
                        )}
                        <Box columnLayout paddingLeft="Xs">
                            {renderChildRoutes(route.childRoutes)}
                        </Box>
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <nav className={style.subNavigationMenu}>
            {props.mainRoute.childRoutes.length === 0 && (
                <NavigationSubMenuItem to={props.mainRoute.path} testId={props.mainRoute.testId}>
                    {t(props.mainRoute.title)}
                </NavigationSubMenuItem>
            )}
            {renderChildRoutes(props.mainRoute.childRoutes)}
        </nav>
    );
};

export default NavigationSubMenu;
